(function ($) {

    $('.pyramid-stage').fadeToggle( 'slow' );

    /* pyramid-chart preview img fake img-map */
    $('.field--name-field-preview').click(function(e) {
        var clickposition = ( e.pageY - $(this).offset().top ) / ( $(this).outerHeight() / 100 );
        if ( clickposition < 35 ) {
            $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-1');
            $('.pyramid-stage').fadeToggle( 'slow' );
            $('.field--name-field-preview').fadeToggle( 'fast' );
        } else if ( clickposition < 55 ) {
            $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-2');
            $('.pyramid-stage').fadeToggle( 'slow' );
            $('.field--name-field-preview').fadeToggle( 'fast' );
        } else if ( clickposition < 75 ) {
            $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-3');
            $('.pyramid-stage').fadeToggle( 'slow' );
            $('.field--name-field-preview').fadeToggle( 'fast' );
        } else {
            $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-4');
            $('.pyramid-stage').fadeToggle( 'slow' );
            $('.field--name-field-preview').fadeToggle( 'fast' );
        }
    });

    var pyramidchartimg = 1;
    $(".pyramid-chart-field-item .pyramid-chart-item-image img").each(function() {
        $(this).addClass( 'hovering test2 pyramid-chart-img-' + pyramidchartimg);
        $(this).clone().appendTo('.pyramid-chart_wrapper .field--name-field-pyramid-chart-background');
        pyramidchartimg++;
    });

    $('.field--name-field-pyramid-chart-background').mousemove(function(e) {

        var hoverposition = ( e.pageY - $(this).offset().top ) / ( $(this).outerHeight() / 100 );
        if ( hoverposition < 35 ) {
            $('.pyramid-chart_wrapper').removeClass('hover-1 hover-2 hover-3 hover-4').addClass('hover-1');
        } else if ( hoverposition < 55 ) {
            $('.pyramid-chart_wrapper').removeClass('hover-1 hover-2 hover-3 hover-4').addClass('hover-2');
        } else if ( hoverposition < 75 ) {
            $('.pyramid-chart_wrapper').removeClass('hover-1 hover-2 hover-3 hover-4').addClass('hover-3');
        } else {
            $('.pyramid-chart_wrapper').removeClass('hover-1 hover-2 hover-3 hover-4').addClass('hover-4');
        }

    });

    $('.field--name-field-pyramid-chart-background').mouseleave(function(e) {
        $('.pyramid-chart_wrapper').removeClass('hover-1 hover-2 hover-3 hover-4');
    });

    /* Pyramiden alternative bei Desktop Anischt */
    var pyramidchartid = 1;
    $(".pyramid-chart-field-item").each(function() {
        $(this).addClass( 'pyramid-chart-id-' + pyramidchartid);
        $(this).find('.pyramid-chart-item-image').remove();
        pyramidchartid++;
    });

    /* active first on load */
    $('.pyramid-chart_wrapper').addClass('active-pal-4');

    /* fake img-map */
    $('.field--name-field-pyramid-chart-background').click(function(e) {
        var clickposition = ( e.pageY - $(this).offset().top ) / ( $(this).outerHeight() / 100 );
        if ( clickposition < 35 ) {
            if ($(".pyramid-chart_wrapper").hasClass("active-pal-1")) {
                $('.pyramid-stage').fadeToggle( 'slow' );
                $('.field--name-field-preview').fadeToggle( 'fast' );
            } else {
                $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-1');
            }
        } else if ( clickposition < 55 ) {
            if ($(".pyramid-chart_wrapper").hasClass("active-pal-2")) {
                $('.pyramid-stage').fadeToggle( 'slow' );
                $('.field--name-field-preview').fadeToggle( 'fast' );
            } else {
                $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-2');
            }
        } else if ( clickposition < 75 ) {
            if ($(".pyramid-chart_wrapper").hasClass("active-pal-3")) {
                $('.pyramid-stage').fadeToggle( 'slow' );
                $('.field--name-field-preview').fadeToggle( 'fast' );
            } else {
                $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-3');
            }
        } else {
            if ($(".pyramid-chart_wrapper").hasClass("active-pal-4")) {
                $('.pyramid-stage').fadeToggle( 'slow' );
                $('.field--name-field-preview').fadeToggle( 'fast' );
            } else {
                $('.pyramid-chart_wrapper').removeClass('active-pal-1 active-pal-2 active-pal-3 active-pal-4').addClass('active-pal-4');
            }
        }
    });

})(jQuery);
